export default __webpack_public_path__ + "assets/svg/no_displays.3d907981.svg";